import { render, staticRenderFns } from "./BranchOfficeControl.vue?vue&type=template&id=1608d9c4&scoped=true&"
import script from "./BranchOfficeControl.vue?vue&type=script&lang=js&"
export * from "./BranchOfficeControl.vue?vue&type=script&lang=js&"
import style0 from "./BranchOfficeControl.vue?vue&type=style&index=0&id=1608d9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608d9c4",
  null
  
)

export default component.exports